import {
  FONT_SIZE_OVERRIDE_REQUEST,
} from './actionTypes';


export default function reducer(state = null, action) {
  switch (action.type) {
    case FONT_SIZE_OVERRIDE_REQUEST:
      return action.fontSizeOverride;
    default:
      return state;
  }
}

// actions
export function updateFontSizeOverride(fontSizeOverride) {
  return {
    type: FONT_SIZE_OVERRIDE_REQUEST,
    fontSizeOverride,
  };
}
